import { useSelector, useDispatch } from 'react-redux';
import {
  // getFiltersData,
  changeDateRange,
  handleLobFilterChange,
  handleTeamFilterChange,
  handleAgentFilterChange,
  handleSetExtraFilterData,
  handleRemoveExtraFilterData,
  handleSetMultipleExtraFilterData,
  handleRemoveMultipleExtraFilterData,
  handleSetMultipleFeatureFilterData,
  handleRemoveFeatureExtraFilterData,
  setFeatureFilter,
  handleChangeAddtionalFields,
  handleChangeAddtionalSubFields,
  clearExtraFilter,
  setExtraFilter,
  handleRemoveMultipleExtraFilterDataFromApplied,
  getInspectConfigData,
  clearLobTeamAgent,
  handleLobAllFilterChange,
  handleAllTeamFilterChange,
  handleAllAgentFilterChange
} from 'store/InspectFilter';

function useInspectFilter() {
  const dispatch = useDispatch();

  const dateRange = useSelector((state) => state.analyzefilter.rangeDate),
    LOB = useSelector((state) => state.analyzefilter.LOB),
    selectedLOB = useSelector((state) => state.analyzefilter.selected.LOB),
    ui = useSelector((state) => state.analyzefilter.ui),
    LOBTeam = useSelector((state) => state.analyzefilter.LOBTeam),
    LOBTeamAgent = useSelector((state) => state.analyzefilter.LOBTeamAgent),
    flag = useSelector((state) => state.analyzefilter.flag),
    filter = useSelector((state) => state.analyzefilter.data),
    filters = useSelector((state) => state.analyzefilter.data?.extra_filter),
    appliedExtraFilters = useSelector((state) => state.analyzefilter.extra_filter),
    appliedFeatureFilters = useSelector((state) => state.analyzefilter.features_filter),
    features_filter = useSelector((state) => state.analyzefilter.data?.feature_filter),
    selectedFilter = useSelector((state) => state.analyzefilter.selected),
    selectedFields = useSelector((state) => state.analyzefilter.selected?.fields),
    selectedRowFilterFields = useSelector((state) => state.analyzefilter.selected?.rowFilter),
    fields = useSelector((state) => state.analyzefilter.fields),
    call_duration = useSelector((state) => state.analyzefilter.data?.extra_filter?.call_duration),
    tenure = useSelector((state) => state.analyzefilter.data?.extra_filter?.tenure),
    shift = useSelector((state) => state.analyzefilter.data?.extra_filter?.shift),
    direction = useSelector((state) => state.analyzefilter.data?.extra_filter?.direction),
    skill_set = useSelector((state) => state.analyzefilter.data?.extra_filter?.skill_set),
    tagging_feature = useSelector((state) => state.analyzefilter.data?.extra_filter?.tagging_feature),
    exo_phone = useSelector((state) => state.analyzefilter.data?.extra_filter?.exo_phone);
  // fieldsConfig = useSelector((state) => state.inspectfilter.fields_config);

  const //getFiltersDataAction = () => dispatch(getFiltersData()),
    changeDateRangeAction = (params) => dispatch(changeDateRange(params)),
    getInspectConfigDataAction = () => dispatch(getInspectConfigData()),
    handleLobFilterChangeAction = (params) => dispatch(handleLobFilterChange(params)),
    handleTeamFilterChangeAction = (params) => dispatch(handleTeamFilterChange(params)),
    handleAgentFilterChangeAction = (params) => dispatch(handleAgentFilterChange(params)),
    handleSetExtraFilterDataAction = (params) => dispatch(handleSetExtraFilterData(params)),
    handleRemoveExtraFilterDataAction = (params) => dispatch(handleRemoveExtraFilterData(params)),
    handleSetMultipleExtraFilterDataAction = (params) => dispatch(handleSetMultipleExtraFilterData(params)),
    handleRemoveMultipleExtraFilterDataAction = (params) => dispatch(handleRemoveMultipleExtraFilterData(params)),
    handleSetMultipleFeatureFilterDataAction = (params) => dispatch(handleSetMultipleFeatureFilterData(params)),
    handleRemoveFeatureExtraFilterDataAction = (params) => dispatch(handleRemoveFeatureExtraFilterData(params)),
    handleRemoveMultipleExtraFilterDataFromAppliedAction = (params) => dispatch(handleRemoveMultipleExtraFilterDataFromApplied(params)),
    handleChangeAddtionalFieldsAction = (params) => dispatch(handleChangeAddtionalFields(params)),
    handleChangeAddtionalSubFieldsAction = (params) => dispatch(handleChangeAddtionalSubFields(params)),
    setFeatureFilterAction = () => dispatch(setFeatureFilter()),
    setExtraFilterAction = () => dispatch(setExtraFilter()),
    clearExtraFilterAction = () => dispatch(clearExtraFilter()),
    clearLobTeamAgentAction = () => dispatch(clearLobTeamAgent()),
    handleLobAllFilterChangeAction = () => dispatch(handleLobAllFilterChange()),
    handleAllTeamFilterChangeAction = () => dispatch(handleAllTeamFilterChange()),
    handleAllAgentFilterChangeAction = () => dispatch(handleAllAgentFilterChange());

  return {
    // state of Filter
    dateRange,
    LOB,
    ui,
    LOBTeam,
    LOBTeamAgent,
    flag,
    filter,
    filters,
    features_filter,
    selectedFilter,
    selectedFields,
    selectedRowFilterFields,
    call_duration,
    tenure,
    shift,
    direction,
    skill_set,
    tagging_feature,
    exo_phone,
    fields,
    // fieldsConfig,
    appliedExtraFilters,
    appliedFeatureFilters,
    selectedLOB,
    // Action of Filter
    // getFiltersDataAction,
    // getLOBDataAction,
    // getAnalyzeConfigDataAction,
    // getAgentBasedTeamDataAction,
    // getLobTeamDataAction,
    changeDateRangeAction,
    handleLobFilterChangeAction,
    handleTeamFilterChangeAction,
    handleAgentFilterChangeAction,
    handleChangeAddtionalFieldsAction,
    handleChangeAddtionalSubFieldsAction,
    handleSetExtraFilterDataAction,
    handleRemoveExtraFilterDataAction,
    handleSetMultipleExtraFilterDataAction,
    handleRemoveMultipleExtraFilterDataAction,
    handleSetMultipleFeatureFilterDataAction,
    handleRemoveFeatureExtraFilterDataAction,
    setFeatureFilterAction,
    setExtraFilterAction,
    clearExtraFilterAction,
    // clearExtraFilterApplyAction,
    handleRemoveMultipleExtraFilterDataFromAppliedAction,
    // setAllfilterFromParentAction,
    // setSelectedDatafromParentAction,
    clearLobTeamAgentAction,
    getInspectConfigDataAction,
    handleLobAllFilterChangeAction,
    handleAllTeamFilterChangeAction,
    handleAllAgentFilterChangeAction
  };
}

export default useInspectFilter;
